import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useStoreState } from 'easy-peasy';

const AuthenticatedRoute = ({ component: Component, ...routeProps }) => {
  const authenticated = useStoreState(state => state.auth.isLoggedIn);

  return (
    <Route
      {...routeProps}
      render={props => (authenticated
                        ? (<Component {...props} />)
                        : (<Redirect to="/login" />))}
    />);
};

export default AuthenticatedRoute;
